import { useState } from "react";

const BOT_REPLY = (msg) => {
  const text = msg.toLowerCase();

  if (text.includes("eye") || text.includes("check")) {
    return "👁 Yes! We provide FREE eye check-up. You can walk in or book via WhatsApp.";
  }

  if (text.includes("time") || text.includes("open")) {
    return "🕒 We are open:\nMon–Sat: 9:00 AM – 8:00 PM\nSun: 10:00 AM – 6:00 PM";
  }

  if (text.includes("frame")) {
    return "🕶 We have metal, rimless, fiber & kids frames. Budget & premium options available.";
  }

  if (text.includes("lens")) {
    return "🔍 We offer branded lenses: anti-glare, blue-cut, photochromic & progressive lenses.";
  }

  if (text.includes("watch")) {
    return "⌚ We sell watches for men, women & kids. Daily wear to premium collections.";
  }

  if (text.includes("offer") || text.includes("discount")) {
    return "🎁 Yes! Seasonal offers are available. Please ask on WhatsApp for latest deals.";
  }

  return "😊 I can help with eye check-up, products, timings & offers. Or chat with us on WhatsApp.";
};

const ChatBot = () => {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    { from: "bot", text: "Hi 👋 How can I help you today?" },
  ]);

  const send = () => {
    if (!input.trim()) return;

    const userMsg = { from: "user", text: input };
    const botMsg = { from: "bot", text: BOT_REPLY(input) };

    setMessages([...messages, userMsg, botMsg]);
    setInput("");
  };

  return (
    <>
      {/* Floating button */}
      <button className="chatbot-float" onClick={() => setOpen(!open)}>
        🤖
      </button>

      {open && (
        <div className="chatbot-box">
          <div className="chatbot-header">
            Popular Watch & Opticals
            <span onClick={() => setOpen(false)}>✕</span>
          </div>

          <div className="chatbot-body">
            {messages.map((m, i) => (
              <div key={i} className={`msg ${m.from}`}>
                {m.text}
              </div>
            ))}
          </div>

          <div className="chatbot-input">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Type your question…"
              onKeyDown={(e) => e.key === "Enter" && send()}
            />
            <button onClick={send}>Send</button>
          </div>

          <a
            href="https://wa.me/919546525492"
            target="_blank"
            rel="noreferrer"
            className="chatbot-wa"
          >
            💬 Chat on WhatsApp
          </a>
        </div>
      )}
    </>
  );
};

export default ChatBot;
